import { ParentProps } from "solid-js";
import { useTable } from "../TableContext";
import style from '../st-table.module.css'

export const Head = (props: ParentProps) => {
    const table = useTable();
    

    return (
        <thead class={style['st-table-head']}>
            <tr class={style['st-table-head-row']} style={`grid-template-rows: repeat(${table.maxHeaderDepth() + 1}, 1fr)`}>
                {props.children}
            </tr>
        </thead>
    )
}